module.exports = __webpack_public_path__ + "img/paper_plane.e7d40dd7.svg";